<template>
  <el-dialog title='关联提货订单' :visible.sync='innerVisible' width='1400px' @close='handleClose'>
    <div class='select-order-container'>
      <!-- 搜索表单 -->
      <el-form :model='searchForm' inline class='search-form'>
        <el-form-item label='提货编号'>
          <el-input clearable v-model='searchForm.pickupNumber' placeholder='请输入提货编号'/>
        </el-form-item>
        <el-form-item label='所属仓库'>
          <el-select v-model='searchForm.warehouseId' filterable clearable placeholder='请选择仓库'>
            <el-option v-for='item in warehouseList' :key='item.warehouseId'
                       :value='item.warehouseId' :label='item.warehouseName'/>
          </el-select>
        </el-form-item>
        <el-form-item label='提货日期'>
          <el-date-picker v-model='dateArr' type='daterange' range-separator='至'
                          start-placeholder='开始日期' end-placeholder='结束日期'
                          format='yyyy-MM-dd' value-format='yyyy-MM-dd'/>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' @click='onSearch'>查询</el-button>
          <el-button @click='onReset'>重置</el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading='loading' ref='multipleTable' :data='recordList' border class='record-table' :height="320" style='width: 100%;'>
        <el-table-column type='selection' width='55'/>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label='品种规格' prop='specName'/>
        <el-table-column min-width="100" label='提货编号' prop='pickupNumber'/>
        <el-table-column prop='vehicleDateStart' label='提货日期'/>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="提货库点" prop="vehicleStartAddressName"></el-table-column>
        <el-table-column prop='pickupPrice' label='提货单价'/>
        <el-table-column prop='pickupQuantity' label='实提数量'/>
      </el-table>

      <!-- 你指定格式的分页组件 -->
      <el-pagination
        class="mt15"
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination>
    </div>

    <div slot='footer' class='dialog-footer'>
      <el-button @click='handleClose'>取消</el-button>
      <el-button type='primary' @click='onSubmit'>确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'YxOrderChoose',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    specId: {
      type: String,
      default: ''
    },
    selectIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      recordList: [],
      searchForm: {
        pickupNumber: '',
        warehouseId: ''
      },
      dateArr: [],
      page: 1,
      total: 0,
      warehouseList: []
    }
  },
  mounted() {
    this.loadWarehouseList()
  },
  watch: {
    visible(val) {
      this.innerVisible = val
      if (val) {
        this.page = 1
        this.resetSearch()
        this.loadData()
      }
    }
  },
  methods: {
    onSubmit() {
      const selectData = this.$refs.multipleTable ? this.$refs.multipleTable.selection : []
      if (selectData && selectData.length > 0) {
        this.$emit('confirm', selectData)
        this.handleClose()
      } else {
        this.$message.error('请选择关联提货订单')
      }
    },
    handleClose() {
      this.innerVisible = false
      this.$emit('close')
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.resetSearch()
      this.loadData()
    },
    resetSearch() {
      this.searchForm = {
        pickupNumber: '',
        warehouseId: ''
      }
      this.dateArr = []
      this.page = 1
    },
    // 加载仓库下拉选项
    loadWarehouseList() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.warehouseList = res.list || []
      })
    },
    // 列表分页查询
    loadData() {
      const params = {
        ycSpecId: this.specId,
        pickupNumber: this.searchForm.pickupNumber,
        warehouseId: this.searchForm.warehouseId,
        page: this.page,
        size: 10
      }
      if (this.dateArr && this.dateArr.length === 2) {
        params.startDate = this.dateArr[0]
        params.endDate = this.dateArr[1]
      }
      this.loading = true
      this.$axios.get(this.$apis.deliveryOrder.selectYxPickupOrderForRelationByPage, params).then(res => {
        if (res) {
          this.recordList = res.list || []
          this.total = res.total || 0
          const selectList = []
          this.recordList.forEach(item => {
            if (this.selectIds.includes(item.pickupId)) {
              selectList.push(item)
            }
          })
          this.$nextTick(() => {
            if (selectList.length && this.$refs.multipleTable) {
              selectList.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item)
              })
            }
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.select-order-container {
  max-height: 500px;
  overflow-y: auto;
}
.search-form {
  margin-bottom: 20px;
}
.record-table {
  margin-bottom: 16px;
}
.mt15 {
  margin-top: 15px;
  text-align: right;
}
.dialog-footer {
  text-align: right;
}
</style>
